export default "__VITE_ASSET__BWeLwR6v__"